import React, { useEffect, useRef, useState } from "react";
import PFF_Img from "../../../assets/images/PDF_img.svg";
import close_btn from "../../../assets/images/close_btn.png";
import { Modal } from "flowbite-react";

const AddBrouchureModal = ({
  openModal,
  selectedFileName,
  setOpenModal,
  setSelectedFileName,
  ven_name,
  setVen_name,
  date,
  setDate,
  error,
  setError,
  handleUploadpdf,
}) => {
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);
  const modalRef = useRef();

  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      handleOutsideClick(event);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setSelectedFileName(e.dataTransfer.files[0]);
    }
  };
  const onButtonClick = () => {
    inputRef.current.click();
  };

  const handleChange = function (e) {
    e.preventDefault();
    setError({ ...error, Filename: "" });
    if (e.target.files && e.target.files[0]) {
      setSelectedFileName(e.target.files[0]);
    }
  };
  const handleChangeinput = function (e) {
    setError({ ...error, venName: "" });
    setVen_name(e.target.value.toLowerCase());
  };

  const handlevalidatepdf = () => {
    const newErrors = {};
    if (!ven_name) {
      newErrors.venName = "Please Enter Vendor Name";
    }
    if (!selectedFileName) {
      newErrors.Filename = "Please Select a File";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
    } else {
      handleUploadpdf();
    }
  };
  return (
    <Modal
      show={openModal}
      onHide={() => setOpenModal(false)}
      keyboard={false} // Prevents closing on pressing the keyboard Esc key
      className="dashboard-modal-main ring-0  bg-opacity-60"
      ref={modalRef}
      size={"4xl"}
    >
      <Modal.Body className="large2  ">
        <div className="space-y-6  w-full">
          <div className="upload-doc-main  flex justify-between my-4 md:my-7">
            <h1 className=" text-xl md:text-3xl font-semibold Campton mb-3 m-auto">
              Upload Document
            </h1>
            <div
              className="close_btn cursor-pointer"
              onClick={() => {
                setOpenModal(false);
                setSelectedFileName("");
                setVen_name("");
                setDate("");
              }}
            >
              <img src={close_btn} alt="" />
            </div>
          </div>
          <div className="upload-doc-modal-body flex-column align-center  md:flex-row flex gap-3 md:gap-4 justify-center">
            <form
              id="form-file-upload"
              className="d-flex flex-column setting p-5 justify-center w-[316px] m-auto"
              onDragEnter={handleDrag}
              // onSubmit={(e) => e.preventDefault()}
            >
              <img src={PFF_Img} alt="" className="h-[100px] " />
              <input
                ref={inputRef}
                type="file"
                id="input-file"
                multiple={true}
                onChange={handleChange}
                className="hidden"
              />
              <label
                id="label-file-upload"
                htmlFor="input-file"
                className={dragActive || selectedFileName ? "drag-active" : ""}
              >
                <div className="flex justify-center align-center ">
                  {selectedFileName ? (
                    <p className="text-ellipsis overflow-hidden ...">
                      {selectedFileName.name}
                    </p>
                  ) : (
                    <p className="Campton">Drag & Drop File to Upload</p>
                  )}
                </div>
              </label>
              {dragActive && (
                <div
                  id="drag-file-element"
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                ></div>
              )}
            </form>

            {selectedFileName ? null : (
              <button
                className="choose-file-btn text-white Campton"
                onClick={onButtonClick}
              >
                Choose file
              </button>
            )}
            <div className="w-full text-center primary">{error?.Filename}</div>
            <div className="ven-div setting m-auto d-flex p-4 mt-3 w-[364px]">
              <input
                placeholder="Input Vendor Name"
                type="text"
                className=" venName Campton text-2xl black m-auto"
                value={ven_name}
                onChange={handleChangeinput}
              />
            </div>
            <div className="w-full text-center primary">{error?.venName}</div>
            <button
              className="choose-file-btn text-white Campton mt-2"
              onClick={() => handlevalidatepdf()}
            >
              Start Analyzing
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddBrouchureModal;
